import { apiService } from '@/services/api/apiService';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';

interface SpiceLevel {
    emoji: any;
    data: SpiceLevel
    id: number;
    spiceLevelName: string;
    // Add other properties if needed
}

interface SpiceState {
    data: SpiceLevel[];
    loading: boolean;
    error: string | null;
}

const PORT = import.meta.env.VITE_COOK_PORT;
const MASTERURL = import.meta.env.VITE_API_COOK_URL;

export const fetchspiceLevel = createAsyncThunk<SpiceLevel[], void, { rejectValue: string }>(
    'spiceLevel/fetchspiceLevel',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.get<{ data: SpiceLevel[] }>('/get_all_spice_level', PORT, MASTERURL);
            return response.data; // Assuming the response has a 'data' field containing the array
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);

export const createspiceLevel = createAsyncThunk<SpiceLevel, any, { rejectValue: string }>(
    'spiceLevel/createspiceLevel',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.post<{ data: SpiceLevel }>('create_spice_level', params, PORT, MASTERURL);
            return response.data; // Assuming the response has a 'data' field containing the new spice level
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);


export const updatespiceLevel = createAsyncThunk<SpiceLevel, any, { rejectValue: string }>(
    'spiceLevel/updatespiceLevel',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.put<{ data: SpiceLevel }>('update_spice_level', params, PORT, MASTERURL);
            return response.data; // Assuming the response has a 'data' field containing the new spice level
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);

export const softDeleteSpiceLevel: any = createAsyncThunk<
    number,
    number
>(
    "SpiceLevel/softDeleteSpiceLevel",
    async (id,) => {
        try {
            const response = await apiService.patch(
                `soft_delete_spice_level?id=${id}`,
                {},
                PORT,
                MASTERURL
            );
            return response



        } catch (error: any) {
            return (
                error?.message || "An error occurred while deleting cuisine type"
            );
        }
    }
);
// Similarly, update updatespiceLevel if needed

export const spiceLevelSlice = createSlice({
    name: 'spiceLevel',
    initialState: {
        data: [],
        loading: false,
        error: null,
    } as SpiceState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchspiceLevel.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchspiceLevel.fulfilled, (state, action: PayloadAction<SpiceLevel[]>) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchspiceLevel.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
            .addCase(createspiceLevel.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createspiceLevel.fulfilled, (state, action: PayloadAction<SpiceLevel>) => {
                state.loading = false;
                state.data.push(action.payload); // Append the new spice level to the existing array
            })
            .addCase(createspiceLevel.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
            .addCase(updatespiceLevel.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updatespiceLevel.fulfilled, (state, action: PayloadAction<SpiceLevel>) => {
                state.loading = false;
                state.data.push(action.payload); // Append the new spice level to the existing array
            })
            .addCase(updatespiceLevel.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
        // Add cases for updatespiceLevel if needed
    },
});

export default spiceLevelSlice.reducer;